export interface DriverTraceViewModel {
  Orderno: string;
  DriverId: number;
  DeviceId: number;
  BegTime: string;
  EndTime: string;
  TraceList: TraceListModel[];
}

export interface TraceListModel {
  GStatus: string;
  Lng: number;
  Lat: number;
  Speed: number;
  Angle: number;
  GTime: string;
}

export interface OrderTraceRecord {
  OrderNo: string;
  StartAddress: string;
  TargetAddress: string;
  StartPosition: FulltyPosition;
  TargetPosition: FulltyPosition;
  EventPoint: OrderEventPoint[];
  Path: FulltyPosition[];
}

export interface OrderEventPoint extends FulltyPosition {
  EventTime: Date;
  Status: OrderEventStatus;
}

export enum OrderEventStatus {
  GOTO,
  ARRIVAL,
  GETON,
  GETOFF,
}

export interface PolyLineData<TRecord> {
  lineList: Array<LineData<TRecord>>;
  beforeLatLng?: google.maps.LatLng;
}

export interface LineData<TRecord> {
  line: google.maps.Polyline;
  record: TRecord;
}

export interface FulltyPosition {
  Latitude: number;
  Longitude: number;
}
